<template>
  <el-dialog
  :visible="visible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  append-to-body
  center
  v-loading.fullscreen.lock="fullScreenLoading"
  @open="open">
    <span slot="title" class="dialog-header">
      <span  class="title" >{{ $t('inventorySettings.priceReconciliationTitle') }}</span>
    </span>
    <el-divider/>
    <el-row v-if="fileUploaded === false">
      <el-col>
        <div style="max-width:400px;word-break: break-word;margin:auto;text-align:center;">
          <p class="bg-info-lighter p-10"><i class="el-icon-warning-outline"></i> {{ $t('inventorySettings.priceReconciliationInstruction') }}</p>
        </div>
      </el-col>
    </el-row>
    <el-row v-if="fileUploaded === false" justify="center" style="text-align:center;margin-top:40px;">
      <el-col class="formContainer" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-upload
          drag
          :http-request="postFile"
         
          :before-upload="beforeUpload"
        
          :file-list="files">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">{{ $t('inventorySettings.reconcileUpdateInstruction1') }} <em>{{ $t('inventorySettings.reconcileUpdateInstruction2') }}</em></div>
          <div class="el-upload__tip" slot="tip">{{$t('inventorySettings.reconcilUploadFileRestriction')}}b</div>
        </el-upload>
      </el-col>
    </el-row>
    <el-row v-else>
      <div v-if="reconciliation.length === 0" class="text-center">
        <span><h2>Félicitations, votre inventaire ne nécessite aucune conciliation car il est à jour!</h2></span>
      </div>
      <div v-else>
        <p>{{ $t('inventorySettings.nbProductLineToInFile') }} <el-tag>{{reconciliation.length}}</el-tag></p>
        <p>Nombre de ligne de produit pouvant être concilié : <el-tag type="success">{{nbGoodLines}}</el-tag></p>
        <p>Nombre de ligne de produit ne pouvant pas être concilié : <el-tag type="danger">{{nbBadLines}}</el-tag></p>
      
        <el-collapse v-model="activeNames" v-if="reconciliation.length > 0" >
          <el-collapse-item title="Produit(s) à concilier" name="1">
            <reconciliationTable @openProduct="openProductDrawer" :data="goodLines"  :selection="true" @selectionChanged="affectSelectedReconciliation" emptyText="Aucune ligne à concilier"></reconciliationTable>
          </el-collapse-item>
          <el-collapse-item title="Produit(s) ne pouvant pas être concilié(s)" name="2">
          <reconciliationTable :data="badLines" :error="true" emptyText="Aucune ligne"></reconciliationTable>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{$t('common.cancel')}}</el-button>
      <el-button :disabled="nbGoodLines==0" type="primary" @click="reconcile">{{$t('inventorySettings.reconcileButton')}} <span v-if="selectedReconciliation.length > 0"> ({{ selectedReconciliation.length }})</span></el-button>
    </span>
    <ProductDetailDrawer
      :puid="puid"
      direction="ltr"
      :visible="productDetailDrawerVisible"
      @close="closeProductDetailDrawer" />
  </el-dialog>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import itemAPI from '@/services/API/items'
import reconciliationTable from './reconciliation-price-table'
import ProductDetailDrawer from '@/views/pages/inventory/components/product-detail-drawer'
import InventoryService from '@/services/API/inventory.js';
import axios from 'axios';

export default {
  name: 'Price-Conciliation',
	props: {
    inventory_id : {
      type : Number,
      require : true
    },
    inventoryName : {
      type : String,
      require:true
    },
    visible : Boolean,

	},
  data() {
    return {
      puid: null,
      productDetailDrawerVisible: false,
      fullScreenLoading : false,
      files : [],
      reconciliation : [],
      selectedReconciliation : [],
      fileUploaded: false,
      reason : null,
      mode : 0,
      activeNames: ['1', '2'],
    };
  },components: {
    reconciliationTable,
    ProductDetailDrawer
  },
	methods: {
    postFile({ file }){
      this.fullScreenLoading=true;
      const formData = new FormData();
      formData.append('file', file);
      return axios.post(this.postAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': localStorage.getItem('access-token'),
          // 'x-portaus-context': localStorage.getItem('portaus-context')
        }
      })
        .then(response => {
          this.fileUploadedSuccess(response.data, file, this.files);
        })
        .catch(err => {
          this.handleFileUploadError(err, file, this.files);
        });
    },
    handleFileUploadError(err, file, fileList){

      console.log("error", err);
      this.fullScreenLoading=false;
      if (_.get(err, 'response.data.errorCode') === 'PRICE_RECONCILIATION_FILE_INCORRECT_FORMAT'){
        this.$message({
          message: this.$i18n.t('inventorySettings.errors.PRICE_RECONCILIATION_FILE_INCORRECT_FORMAT'),
          type: 'error'
        });
      } else if (_.get(err, 'response.data.errorCode') === 'PRICE_RECONCILIATION_FILE_EMPTY') {
        this.$message({
          message: this.$i18n.t('inventorySettings.errors.PRICE_RECONCILIATION_FILE_EMPTY'),
          type: 'error'
        });
      } else {
        this.$message({
          message: this.$i18n.t('inventorySettings.errors.PRICE_RECONCILIATION_FILE_GENERIC_ERROR'),
          type: 'error'
        });
      }
   
    },
    openProductDrawer(puid){
      this.puid = puid;
      this.productDetailDrawerVisible = true;
    },
    closeProductDetailDrawer(){
      this.productDetailDrawerVisible = false;
    },
    affectSelectedReconciliation(selection){
      this.selectedReconciliation=selection;
    },
    open(){
    
    },
    beforeUpload(){
      this.fullScreenLoading=true;
    },
    fileUploadedSuccess(response, file, fileList){
      this.fullScreenLoading=false;
      this.reconciliation = response;
      this.fileUploaded = true;
    },
    reset(){
      this.files = [];
      this.reconciliation = [];
      this.activeNames=['1','2'];
    },
    close(){
      this.$emit('close');
      this.fileUploaded = false;
      this.reset();
    },
   
    reconcile(){
      this.fullScreenLoading=true;
      const params = [];

      _.forEach(this.selectedReconciliation, i=>{
        params.push({
          puid: i.puid,
          productId: i.productId,
          items: i.reconcileItem.items,
          newLicenseePrice: i.reconcileItem.newLicenseePrice,
          newRetailPrice: i.reconcileItem.newRetailPrice,
          newSellingUnitPrice: i.reconcileItem.product.sellingUnitPrice,
          newAgencyFee: i.reconcileItem.product.agencyFee != null ? parseFloat(i.reconcileItem.product.agencyFee) : undefined,
        });
      });
      return InventoryService.processReconciliationPrice(this.inventory_id, params)
        .then(()=>{
          this.fullScreenLoading=false;
          this.invalidateStockItems();
          this.$message({
            message: 'Conciliation effectuée avec succès!',
            type: 'success'
          });
          this.close();
        }).catch(err=>{
          this.fullScreenLoading=false;
          this.$message({
            message: 'Une erreur est survenue lors de la conciliation. Veuillez réessayer plus tard. ' + err,
            type: 'error'
          });

        })
    },
    getHeaders(){
      var headers = {};
      headers.Authorization = localStorage.getItem('access-token')
      headers['x-portaus-context'] = localStorage.getItem('portaus-context')
      return headers;
    },
    ...mapActions('stockItems',['invalidateStockItems'])
	},
	computed: {
    postAction(){
      return process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/inventories/"+this.inventory_id+"/reconciliation-files/prices";
    },
    nbGoodLines(){
      return _.size(this.goodLines);
    },
    nbBadLines(){
      return _.size(this.badLines)
    },
    goodLines(){
      let goodLines=[];
      _.forEach(this.reconciliation, i=>{if(i.reconcile === true && i.error === false)goodLines.push(i);})
      return goodLines;
    },
    badLines(){
      let badLines=[];
      _.forEach(this.reconciliation, i=>{if(i.error === true)badLines.push(i);})
      return badLines;
    }
	},
  created(){

  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';


.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.title {
	font-size : 1.8em;
	font-weight:bold;

}


.el-card__body, .el-card{
	position:relative;
}

.dotted-card:hover{
	cursor:pointer;
	color: #4A596A;
}

@media (max-width: 1024px) {


}

</style>
